import { t } from '../../app/i18n';

export default {
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  ENTER_SMS_CODE_CONTRACT: 'ENTER_SMS_CODE_CONTRACT',
  SIGN_CONTRACT: 'SIGN_CONTRACT',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
  WAIT_FOR_DOCUMENT_CONFIRMATION: 'WAIT_FOR_DOCUMENT_CONFIRMATION',
  GENERAL_CONTRACT_SIGN: 'GENERAL_CONTRACT_SIGN',
};

export const translation = {
  CONFIRM_EMAIL: t(
    'Na Vašu e-mailovú adresu, ktorú ste zadali pri registrácii, sme odoslali aktivačný e-mail. Prosím, skontrolujte svoju schránku a postupujte podľa pokynov v e-maili.'
  ),
  ENTER_SMS_CODE_CONTRACT: t('Zadajte SMS kód pre overenie'),
  SIGN_CONTRACT: t(
    'Vaša identita bola úspešne overená. Pre využívanie našich služieb prosím jednorazovo potvrďte rámcovú zmluvu.'
  ),
  UPDATE_PROFILE: t('Doplňte si profilové údaje'),
  UPLOAD_DOCUMENTS: t(
    'Ďakujeme, že ste potvrdili Váš e-mail. Pre investovanie a overenie identity je potrebné nahrať sken občianskeho preukazu.'
  ),
  WAIT_FOR_DOCUMENT_CONFIRMATION: t('Čakajte na schválenie dokumentov administrátorom'),
  GENERAL_CONTRACT_SIGN: t(
    'Vážený investor, pripravili sme pre Vás novú verziu Investorskej rámcovej zmluvy. Pred realizovaním novej investície kliknite na tento odkaz, prečítajte a schváľte prosím novú verziu dokumentu.'
  ),
};



// WEBPACK FOOTER //
// ./src/common/enums/creditorRegistrationActions.js